module.exports = __webpack_public_path__ + "static/img/行销-4.cfa83823.png";